// extracted by mini-css-extract-plugin
export var banner = "_ti-0";
export var settingRow = "_ti-2";
export var titleIcon = "_ti-1";